import { parseHighlightedText } from '../../utils/parseHighlightedText';

import styles from '../../SingleEvent.module.scss';
import { ISingleEventParticipationCriteria } from '../../types';

type ParticipationCriteriaSectionProps = {
  criteria: ISingleEventParticipationCriteria[];
};

const ParticipationCriteriaSection = ({ criteria }: ParticipationCriteriaSectionProps) => {
  // Split value by newlines and parse each line separately
  const parseMultilineText = (text: string) => {
    return text.split('\n').map((line, lineIndex) => (
      <span key={lineIndex}>
        {parseHighlightedText(line)}
        {lineIndex < text.split('\n').length - 1 && <br />}
      </span>
    ));
  };

  return (
    // `id` is the anchor the eligibility note under My Statistics jumps to. That note
    // exists because a member's headline WNFT count is NOT their event-qualifying count,
    // and the rules that explain the difference live here.
    <div id="participation-criteria" className="tw-mx-auto tw-max-w-[960px] tw-px-[20px] lg:tw-px-0">
      <h2 className={styles.sectionHeader}>Participation Criteria</h2>
      <div className="tw-h-[30px] lg:tw-h-[60px]" />
      <div className="tw-flex tw-flex-col tw-gap-[20px] tw-text-left">
        {criteria.map((item, index) => (
          <div key={index}>
            <p className="tw-mb-[10px] tw-text-[24px] tw-font-bold tw-uppercase tw-text-turquoise">{item.name}</p>
            <p className="tw-text-[16px] tw-text-white">{parseMultilineText(item.value)}</p>
          </div>
        ))}
      </div>
      {/* NOTICE: temporary disabled */}
      {/* <div className="tw-h-[30px] lg:tw-h-[60px]" />
      <Button text="Join Now" size="medium" className="tw-min-w-[226px]" /> */}
    </div>
  );
};

export default ParticipationCriteriaSection;
